import { Component, ViewChild, ElementRef, Input, OnInit, ViewContainerRef, Output, EventEmitter } from '@angular/core';
import { Chart, Tooltip } from 'chart.js/auto';
import { TootipService } from '../tooltip/tootip.service';
import * as moment from 'moment';
import * as _ from 'lodash';
import { start } from '@popperjs/core';
import { NgFor, NgClass } from '@angular/common';
import { TooltipComponent } from '../tooltip/tooltip.component';
@Component({
    selector: 'app-ltms-bar-chart-view',
    templateUrl: './ltms-bar-chart-view.component.html',
    styleUrls: ['./ltms-bar-chart-view.component.scss'],
    imports: [NgFor, NgClass, TooltipComponent]
})
export class LtmsBarChartViewComponent implements OnInit {
  @ViewChild('chartCanvas', { static: true }) chartCanvas!: ElementRef<HTMLCanvasElement>;
  @Input() config: any = {}
  @Input() componentId: string = '';
  @Output() onSelect = new EventEmitter<any>()
  private chartInstance: Chart | any;

  canvasId: string = "ltms-bar-chart"
  xValues: any[] = [];
  yValues: any[] = [];
  tooltipValues: any[] = [];
  legendItems: any[] = [];
  isFullscreen: boolean = false;
  yMin: number = 0;
  yMax: number = 0;
  oriantation: number = 90
  legendDisplay: boolean = false
  gradientColors: any = ['#66B846', '#66B8460F']
  borderColor: any = '#66B846'
  pointBorderColor: any = 'white'
  pointBackgroundColor: string = 'rgba(102, 184, 70, 1)'
  pointHoverBackgroundColor: string = '#66B846'
  lengendPosition: string = 'bottom'
  dateFormats: any = {
    'Hourly': "hh:mm A",
    'Daily': "DD MMM 'YY",
    'Weekly': "DD MMM 'YY",
    'Monthly': "MMM 'YY",
    'Quarterly': "MMM 'YY",
    'Yearly': "YYYY",
  }
  legendConfig: any = {
    display: true,
    position: 'bottom',
    labels: {
      usePointStyle: true,
      boxWidth: 10,
      padding: 10
    }
  }

  trendType: string = 'Hourly'
  chartTitle: string = '';
  chartDescription: string = '';

  xAxisConfig: any = {};
  yAxisConfig: any = {}
  axisConfig: any = {
    title: {
      padding: {
        top: 12
      },
      display: true,
      text: "< Label Name >",
      font: {
        size: 14,
        family: 'Asap'
      },
      // color: '#000000',
    },
    tick_font: {
      family: 'Asap',
      size: 13,
      lineHeight: 0.16,
    }
  }
  dataSetSchema: any = {
    label: '',
    data: [],
    borderColor: '#0B7139',
    backgroundColor: '#0B7139',
    maxBarThickness: 60,
    categoryPercentage: 0.8,
    barPercentage: 1
  }
  datasets: any = []
  // tooltip config
  tooltipId: string = "bar-chart-tooltip"
  tooltipTitle: string = ''
  tooltipData: any = []
  tooltipFields: any = []
  chartType: string= 'stack'
  constructor(public _tootipService: TootipService) { }
  ngOnInit(): void {
    this.initChart()
  }
  ngOnChanges() {
    this.initChart()
  }

  clone(data: any) {
    return JSON.parse(JSON.stringify(data))
  }

  /**
   * Formats y-axis values based on the formatYAxis flag
   * @param value - The numeric value to format
   * @param formatYAxis - Flag to determine formatting style
   * @returns Formatted string value
   */
  formatCompactNumber(value: number, formatYAxis: boolean = false): string {
    if (!formatYAxis) {
      // Return comma-separated format (e.g., 1,500)
      return value.toLocaleString();
    } else {
      // Return K/M format (e.g., 1.5K for 1,500)
      if (value >= 1000000) {
        return (value / 1000000).toFixed(1) + 'M';
      } else if (value >= 1000) {
        return (value / 1000).toFixed(1) + 'K';
      } else {
        return value.toString();
      }
    }
  }

  /**
   * Gets the formatCompactYAxis flag from config with fallback
   * @returns boolean indicating whether to use K/M formatting
   */
  getFormatCompactYAxisFlag(): boolean {
    return _.get(this.config, 'formatCompactYAxis', false);
  }

  initChart() {
    this.xValues = _.get(this.config, 'chart.xValues', []);
    this.yValues = _.get(this.config, 'chart.yValues', []);
    this.tooltipData = _.get(this.config, 'chart.tooltipData', []);
    this.tooltipFields = _.get(this.config, 'chart.tooltipFields', []);

    this.canvasId = _.get(this.config, 'chartId', this.canvasId);
    this.chartType = _.get(this.config, 'chartType', this.chartType);
    this.oriantation = _.get(this.config, 'chart.oriantation', this.oriantation);
    this.legendDisplay = _.get(this.config, 'chart.legendDisplay', false);
    this.chartTitle = _.get(this.config, 'chart.title', this.chartTitle);
    this.trendType = _.get(this.config, 'chart.trendType', this.trendType);
    this.chartDescription = _.get(this.config, 'chart.description', this.chartDescription);
    
    this.legendConfig = _.merge(this.legendConfig, _.get(this.config, 'legendConfig', {}));
    this.xAxisConfig = _.merge(this.clone(this.axisConfig), _.get(this.config, 'xAxis', {}));
    this.yAxisConfig = _.merge(this.clone(this.axisConfig), _.get(this.config, 'yAxis', {}));

    this.gradientColors = _.get(this.config, 'chart.gradientColors', this.gradientColors);
    this.borderColor = _.get(this.config, 'chart.borderColor', this.borderColor);
    this.pointBorderColor = _.get(this.config, 'chart.pointBorderColor', this.pointBorderColor);
    this.pointBackgroundColor = _.get(this.config, 'chart.pointBackgroundColor', this.pointBackgroundColor);
    this.pointHoverBackgroundColor = _.get(this.config, 'chart.pointHoverBackgroundColor', this.pointHoverBackgroundColor);
    if (this.chartType == 'bar' && this.yValues.length > 1) {
      if (this.xValues.length < 4) {
        this.dataSetSchema.maxBarThickness = undefined;
        this.dataSetSchema.categoryPercentage = this.xValues.length/8;
      }
      else if (this.xValues.length < 7) {
        this.dataSetSchema.maxBarThickness = undefined;
        this.dataSetSchema.categoryPercentage = this.xValues.length/12;
      }
      else{
        // this.dataSetSchema.maxBarThickness = undefined;
        this.dataSetSchema.categoryPercentage = 0.75;
      }
    }
    
    this.datasets = _.map(this.yValues, (value: any) => {
      return _.merge(this.clone(this.dataSetSchema), value);
    });
    this.legendItems = this.datasets.map((dataset: any) => ({
      label: dataset.label,
      borderColor: dataset.borderColor,
    }));
    this.showChart();
  }



  private showChart(): void {
    const self = this;
    this.destroyChart();
    // this._tootipService.tooltipPositionHandeler();
    const ctx = this.chartCanvas.nativeElement.getContext('2d');
    if (ctx) {
      var gradient = ctx.createLinearGradient(0, 0, 0, 250);
      _.each(this.gradientColors, (color: string, index: number) => {
        gradient.addColorStop(index, color);
      });


      this.chartInstance = new Chart(ctx, {
        type: 'bar',
        data: {
          labels: this.xValues,
          datasets: this.datasets.map(dataset => ({
            ...dataset,
            hoverBackgroundColor: dataset.backgroundColor, // Prevent hover color change
            hoverBorderColor: dataset.borderColor,          // Prevent hover border color change
            hoverBorderWidth: 0,                             // Optional: Remove hover border effect
          })),
        },
        options: {
          animation: {
            duration: 0
          },         
          responsive: true,
          maintainAspectRatio: false,
          aspectRatio: 2,
          interaction: {
            intersect: false,
            mode: 'index',
          },
          scales: {
            x: {
              stacked: (this.chartType == 'stack') ? true : false,
              grid: {
                display: false
              },
              ticks: {
                maxRotation: 90,
                minRotation: 90,
                color: _.get(this.xAxisConfig, 'tick_color', '#7F7F7F'),
                font: {
                  size: 13, // Optional: Define font size
                  family: 'Asap', // Optional: Define font family
                  weight: 500, // Add font weight property here
                },
                callback: function (val: any, index: any) {
                  // format string to specific date format if string is date string else return label
                  const label = this.getLabelForValue(val);
                  if (moment(label).isValid() && self.dateFormats[self.trendType]) {
                    if (self.trendType == 'Quarterly') {
                      return moment(label).format('MMM') + "-" + moment(label).endOf('quarter').format('MMM') + " " + moment(label).format("'YY");
                    }
                    return moment(label).format(self.dateFormats[self.trendType]);
                  } else {
                    return label;
                  }
                },
              },
              title: _.get(this.xAxisConfig, 'title', {
                display: true,
                text: "Request Week (start date)",
                font: {
                  size: 14, // Optional: Define font size
                  family: 'Asap', // Optional: Define font family
                  weight: '500', // Add font weight property here
                },
                color: '#000000',
              }),
            },
            y: {
              stacked: (this.chartType == 'stack') ? true : false,
              title: _.get(this.yAxisConfig, 'title', {
                display: true,
                text: "Response",
                color: '#7F7F7F',
              }),
              beginAtZero: true,
              ticks:{
                precision : 0,
                callback: function(value: any, index: any) {
                  return self.formatCompactNumber(value, self.getFormatCompactYAxisFlag());
                }
              }
            },
          },
          plugins: {
            legend: {
              ...this.legendConfig,
              display:false,
              labels: {
                usePointStyle: true, // Enable custom point style
                pointStyle: 'rectRounded', // Set to square
                boxWidth: 15, // Adjust box size (optional)
                padding: 10, // Adjust padding (optional)
                font: {
                  style: 'normal', // Font style
                  weight: 'normal', // Font weight
                  size: 14, // Font size
                  lineHeight: 25 / 18, // Line height
                  family: 'Asap', // Font family
                },
                color: '#000000', // Text color
              },
              onHover: (event: any, legendItem: any) => {
                const canvas = this.chartCanvas.nativeElement;
                canvas.style.cursor = 'pointer'; // Change cursor to pointer
              },
              onLeave: (event: any, legendItem: any) => {
                const canvas = this.chartCanvas.nativeElement;
                canvas.style.cursor = 'default'; // Reset cursor to default
              },
            },
            tooltip: {
              enabled: false,
              position: 'nearest',
              external: function (context) {
                const data = self._tootipService.tooltipHandler(context, {
                  dateFormats: self.dateFormats,
                  trendType: self.trendType,
                  tooltipId: self.tooltipId,
                  tooltipFields: self.tooltipFields,
                  tooltipData: self.tooltipData,
                });
                self.tooltipValues = data.tooltipValues;
                self.tooltipTitle = data.tooltipTitle;
              },
            },
          },
          onHover: (event: any, chartElement: any) => {
            const canvas = this.chartCanvas.nativeElement;
            const elements = this.chartInstance.getElementsAtEventForMode(event, 'nearest', { intersect: true });
            if (elements.length > 0 && this.config?.enable_click) {
              canvas.style.cursor = 'pointer';
            } else {
              canvas.style.cursor = 'default'; 
            }
          },
          onClick: (event: any, element: any, chart: any) => {
            const elements = this.chartInstance.getElementsAtEventForMode(event, 'nearest', { intersect: true });
            if (elements.length > 0 && this.config?.enable_click) {
              const { 0: { index: index } } = element;
              const { data: { labels: labels, datasets: datasets } } = chart;
              let label = labels[index];
              const eventData:any ={
                index: index,
                data: {
                  labels: labels,
                  datasets: datasets
                },
                values: {
                  label: label,
                  datesets: _.map(datasets, (dataset: any) => {
                    return {
                      label: dataset.label,
                      value: dataset.data[index]
                    }
                  })
                }
              }
              if(moment(label).isValid()){
                const dateRange = this.getDateRange(label,this.trendType)
                eventData.dateRange = dateRange
              }
              this.onSelect.emit(eventData)
            }
          }
        },
      });
    }
  }

  private destroyChart(): void {
    if (this.chartInstance) {
      this.chartInstance.destroy();
      this.chartInstance = undefined;
    }
  }

  private getDateRange(dateString:string,trendType:string){
    const startDate = moment(dateString).startOf('day')
    let endDate:any = ''
    switch(trendType){
      
      case 'Weekly':
        endDate = moment(startDate).endOf('week').add(1, 'day')
        break;
      case 'Monthly':
        endDate = moment(startDate).endOf('month')
        break;
      case 'Quarterly':
        endDate = moment(startDate).endOf('quarter');
        break;
      case 'Yearly':
        endDate = moment(startDate).endOf('year');
        break;
      case 'Hourly':
      case 'Daily':
      default:
          endDate = moment(startDate).endOf('day')
           break;
    }
    return {
      startDate:moment(startDate).format('YYYYMMDD'),
      endDate:moment(endDate).format('YYYYMMDD')
    }
  }

  toggleDatasetVisibility(index: number) {
    const chart = this.chartInstance;
    const datasetMeta = chart.getDatasetMeta(index);
    const isVisible = datasetMeta.hidden === null || datasetMeta.hidden === false;

    // Check if any dataset is hidden
    const anyHidden = chart.data.datasets.some((dataset, i) => {
      const meta = chart.getDatasetMeta(i);
      return meta.hidden === true;
    });

    if ((datasetMeta.hidden === null || datasetMeta.hidden === false) && anyHidden) {
      chart.data.datasets.forEach((dataset, i) => {
        const meta = chart.getDatasetMeta(i);
        if (i !== index) {
          meta.hidden = false;
        }
      });
    } else {
      chart.data.datasets.forEach((dataset, i) => {
        const meta = chart.getDatasetMeta(i);
        meta.hidden = true;
      });
      datasetMeta.hidden = false;
    }

    chart.update();
  }
  isAllVisible() {
    return this.chartInstance.data.datasets.every((dataset, i) => {
      const meta = this.chartInstance.getDatasetMeta(i);
      return meta.hidden === false || meta.hidden === null;
    });
  }
  
  isAnyVisible() {
    return this.chartInstance.data.datasets.some((dataset, i) => {
      const meta = this.chartInstance.getDatasetMeta(i);
      return meta.hidden === false || meta.hidden === null;
    });
  }
  
  isSelected(index: number) {
    const meta = this.chartInstance.getDatasetMeta(index);
    return meta.hidden === false || meta.hidden === null;
  }
  
  isNoneSelected() {
    return !this.chartInstance.data.datasets.some((dataset, i) => {
      const meta = this.chartInstance.getDatasetMeta(i);
      return meta.hidden === true;
    });
  }
  
}
